<template>
  <div>
    <div class="hero section-type-b bground-config-clean presentation">
      <div class="row section-type-b pt-5">
        <div class="col-12 presentation-inner-padding-top2">
          <div>
            <h1 class="text-center text-light">
              Contamos con las mejores promociones
            </h1>
          </div>
          <div class="section-type-c pt-5 mb-64">
            <div class="personal-container">
              <div class="row fondo">
                <div
                  v-for="promo in promos"
                  class="col-12 col-md-6 col-lg-4 p-3"
                >
                  <img :src="promo.portada" class="mw-100" alt="" />
                  <h3 class="mt-2 p-2">
                    <a :href="'/description/' + promo.vehiculo_id">{{
                      promo.promocion
                    }}</a>
                  </h3>
                  <p class="mt-2 p-2">
                    {{ promo.descripcion }}
                  </p>
                </div>
                <!-- <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-29-37.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-29-40.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-29-44.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-29-48.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-29-55.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-02.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-06.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-08.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-12.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-21.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4 p-3">
                  <img
                    src="@/assets/images/promociones/photo_2020-08-06_15-30-25.jpg"
                    class="mw-100"
                    alt=""
                  />
                  <h3 class="mt-2 p-2">Lorem ipsum dolor sit a met</h3>
                  <p class="mt-2 p-2">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Error mollitia dolores maiores laboriosam quisquam quidem.
                  </p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Promociones",
  data() {
    return {
      promos: [],
    };
  },
  mounted() {
    this.getDataLocalAPI();
  },
  methods: {
    async getDataLocalAPI() {
      const responseLocalAPI = await this.$http.get(
        `${this.API_URL}/web/promo`
      );
      this.promos = responseLocalAPI.data.data;
    },
  },
};
</script>

<style scoped>
.fondo {
  background: url(https://www.toptal.com/designers/subtlepatterns/patterns/interlaced.png);
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>
